import type { FeatureFlagTypes } from '@/shared/types';

/**
 * LaunchDarkly flag key as configured in LD (and as returned by
 * ``identify()`` / ``variation()``). Only ``useFlags()`` camelCases it.
 */
export const QUESTION_BAR_MIGRATION_LD_KEY = 'question-bar-migration';

/** React SDK ``useFlags()`` key for the same flag. */
export const QUESTION_BAR_MIGRATION_FLAG = 'questionBarMigration';

type FeatureFlags = Record<string, FeatureFlagTypes | undefined> | null | undefined;

/**
 * Fail closed so a missing, malformed, or not-yet-loaded flag keeps the
 * legacy question bar.
 *
 * Reads the camelCased ``useFlags()`` key. Do not pass ``identify()`` maps
 * here — those keep {@link QUESTION_BAR_MIGRATION_LD_KEY}.
 */
export function isQuestionBarMigrationEnabled(flags: FeatureFlags): boolean {
  return flags?.[QUESTION_BAR_MIGRATION_FLAG] === true;
}
